<template>
  <div class="calico-chip">
    <h2 class="label--medium">
      {{ text }}
    </h2>
  </div>
</template>
  
  <script>
  export default {
    name: "CalicoChip",
    props: {
      text: {
        type: String,
        required: true
      }
    }
  };
  </script>
  
  <style scoped lang="scss">
  .calico-chip {
    border-radius: 100px;
    border: 2px solid $color-black;
    padding: $space-small $space-large;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    min-width: max-content;
    .label--medium {
      color: $color-black;
      word-wrap: break-word;
      overflow-wrap: break-word;
      margin: 0;
    }
  }
  </style>
  